import { useSyncExternalStore } from 'react';
import { getAttendanceState, listMyPropustky } from 'api/attendance';

// ==============================|| SHARED ATTENDANCE CLOCK STATE ||============================== //
// Real bug fixed (2026-08-29, na výslovné přání uživatele - "u všech
// tlačítek... je potřeba sledovat stav z jakéhokoliv tlačítka na příslušnou
// akci, aby se změnily všechny i při otevřeném offcanvasu"). Rychlé
// tlačítko v hlavičce (Profile/index.jsx) a "Odchod nebo příchod" v
// AttendanceAccordion.jsx dřív měly každé svůj VLASTNÍ `useState` - píchnutí
// přes jedno z nich druhé vůbec nezaregistrovalo, dokud se offcanvas
// nezavřel a znovu neotevřel (oba komponenty se tím při zavření/otevření
// znovu mountují a natáhnou stav čerstvě). Tenhle modul je jeden sdílený
// "external store" (React 18+ `useSyncExternalStore`, žádná další
// závislost) - kdokoliv zavolá `setSharedClockState()`, KAŽDÁ komponenta
// používající `useSharedClockState()` se hned překreslí s novou hodnotou,
// i když offcanvas mezitím zůstal otevřený.

let clockState;
const listeners = new Set();

function emitChange() {
  for (const listener of listeners) listener();
}

export function setSharedClockState(next) {
  clockState = next;
  emitChange();
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return clockState;
}

export function useSharedClockState() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

// Volitelně zavolatelné z kteréhokoliv místa, co potřebuje čerstvý stav ze
// serveru (např. při rozbalení/otevření) - výsledek se propíše všem
// odběratelům přes setSharedClockState() výše, ne jen volajícímu.
export function refreshSharedClockState() {
  return getAttendanceState()
    .then((d) => setSharedClockState(d.state))
    .catch(() => {});
}

// Stejný sdílený "external store" vzor, teď i pro "mám otevřenou propustku"
// (2026-08-31, na výslovné přání uživatele) - Profile/index.jsx potřebuje
// vědět, jestli právě běží propustka, aby místo "Jste/Nejste v práci"
// ukázal "PROBÍHÁ PROPUSTKA", i když samotný záznam se čte/mění jen v
// AttendanceAccordion.jsx.
let openPropustka;
const propustkaListeners = new Set();

function emitPropustkaChange() {
  for (const listener of propustkaListeners) listener();
}

export function setSharedOpenPropustka(next) {
  openPropustka = next;
  emitPropustkaChange();
}

function subscribePropustka(listener) {
  propustkaListeners.add(listener);
  return () => propustkaListeners.delete(listener);
}

function getPropustkaSnapshot() {
  return openPropustka;
}

export function useSharedOpenPropustka() {
  return useSyncExternalStore(subscribePropustka, getPropustkaSnapshot);
}

export function refreshSharedOpenPropustka() {
  return listMyPropustky()
    .then((rows) => setSharedOpenPropustka(rows.find((p) => !p.return_time) ?? null))
    .catch(() => {});
}
